



























































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import { EstadoCivilPaciente } from '../../../../back/src/types';
import {
  estadoCivilItems,
  escolaridadeItems,
  tipoTelefoneIcons,
  tipoTelefoneItems,
  tipoTelefoneStrings,
} from '../../utils/constants';

export default Vue.extend({
  name: 'ThePacientesCadastroExternoEtapa2',
  data() {
    return {
      valid: false,
      loading: {
        email: false,
      },
      form: {
        nome: '',
        email: '',
        tipoTelefone1: null,
        telefone1: '',
        tipoTelefone2: null,
        telefone2: '',
        rg: '',
        dataNascimento: null,
        profissao: '',
        escolaridade: null,
        estadoCivil: null,
        estadoCivilOutro: '',
      },
      errorMessages: {
        email: [],
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        maxLen(maxLength: number) {
          return [
            (v: string) => !!v || 'Campo obrigatório',
            (v: string) => (!!v && v.length <= maxLength) || `Não pode conter mais que ${maxLength} caracteres`,
          ];
        },
        email: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const emailPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return (v && emailPattern.test(v)) || 'E-mail inválido';
          },
        ],
        date: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            if (!v) return true;
            const date = v.split('/').reverse().join('-');
            const momentDate = moment(date);
            return (v && momentDate.isValid() && momentDate.isAfter('1900-01-01'))
              || 'Data inválida';
          },
        ],
      },
      items: {
        tipoTelefone: tipoTelefoneItems,
        estadoCivil: estadoCivilItems,
        escolaridade: escolaridadeItems,
      },
      EstadoCivilPaciente,
    };
  },
  computed: {
    formEtapa2(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formEtapa2 as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
  },
  mounted() {
    const formStore = this.$store.getters.pacienteFormExternoEtapa2;
    if (!_.isEmpty(formStore)) {
      this.form.nome = formStore.nome || '';
      this.form.email = formStore.email || '';
      this.form.tipoTelefone1 = formStore.tipoTelefone1 || null;
      this.form.telefone1 = formStore.telefone1 || '';
      this.form.tipoTelefone2 = formStore.tipoTelefone2 || null;
      this.form.telefone2 = formStore.telefone2 || '';
      this.form.rg = formStore.rg || '';
      if (formStore.dataNascimento) {
        const momentDataNascimento = moment(formStore.dataNascimento);
        this.form.dataNascimento = momentDataNascimento.isValid()
          ? momentDataNascimento.format('DD/MM/YYYY')
          : null;
      } else {
        this.form.dataNascimento = null;
      }
      this.form.profissao = formStore.profissao || '';
      this.form.escolaridade = formStore.escolaridade || null;
      this.form.estadoCivil = formStore.estadoCivil || null;
      this.form.estadoCivilOutro = formStore.estadoCivilOutro || '';
    }
    this.formEtapa2.resetValidation();
  },
  methods: {
    async validaEmail() {
      this.loading.email = true;
      if (this.form.email.length === 0) {
        this.errorMessages.email = [];
        this.loading.email = false;
        return;
      }
      try {
        const response = await Requester.paciente.validaEmail(this.form.email);
        if (response.errors.length > 0) {
          this.errorMessages.email = response.errors;
        } else {
          this.errorMessages.email = [];
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.email = false;
      }
    },
    maskTelefone(telefone: string) : string {
      if (telefone.length > 14) {
        return '(##) #####-####';
      }
      return '(##) ####-#####';
    },
    iconTelefone(tipoTelefone: string) : string {
      if (_.has(tipoTelefoneIcons, tipoTelefone)) {
        return tipoTelefoneIcons[tipoTelefone];
      }
      return '';
    },
    placeholderTelefone(tipoTelefone: string): string {
      if (_.has(tipoTelefoneStrings, tipoTelefone)) {
        return tipoTelefoneStrings[tipoTelefone];
      }
      return '';
    },
    voltar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa2', this.form);
      this.$emit('voltar');
    },
    continuar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa2', this.form);
      if (!this.formEtapa2.validate()) {
        return;
      }
      this.$emit('etapaValida', this.form);
    },
  },
});
